// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
// import { getFirestore, collection, addDoc, query, where, getDocs } from 'firebase/firestore';
// import styles from './authStyles.module.css';
// import logoImage from '../Images/stackFrameWhite.png';

// // Basic Modal Component for displaying messages
// const Modal = ({ message, onClose }) => (
//   <div className={styles.signUpModal}>
//     <h2>Error Signing Up</h2>
//     <p>{message}</p>
//     <button onClick={onClose}>Close</button>
//   </div>
// );

// function SignUpComponent() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');
//   const navigate = useNavigate();

//   const handleSignUp = async () => {
//     const auth = getAuth();
//     const db = getFirestore();

//     // Check for an existing user with the same email and origin "stackFrame"
//     const usersRef = collection(db, 'users');
//     const usersQuery = query(usersRef, where('email', '==', email), where('origin', '==', 'stackFrame'));

//     try {
//       const querySnapshot = await getDocs(usersQuery);
//       if (!querySnapshot.empty) {
//         // Found a user with the same email
//         setModalMessage('This email is already in use for a stackFrame account. Please use a different email.');
//         setShowModal(true);
//         return;
//       }

//       const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//       // If successful, add user details to Firestore
//       await addDoc(usersRef, {
//         uid: userCredential.user.uid,
//         email: email,
//         hasPaid: false,
//         origin: "stackFrame",
//       });

//       navigate('/'); // Navigate to the dashboard
//     } catch (error) {
//       console.error("Error signing up:", error);
//       if (error.code === 'auth/email-already-in-use') {
//         setModalMessage('This email is already in use, please try again with another email.');
//       } else {
//         setModalMessage('An error occurred during sign up. Please try again.');
//       }
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className={styles.parentContainer}>
//       <div className={styles.container}>
//         <div className={styles.stackFrame}>
//           <img src={logoImage} alt="stackFrame Logo" style={{ width: '34px', height: '34px' }} />
//           <span className={styles.stackFrameText}>stackFrame</span>
//         </div>
//         <input className={styles.inputField} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
//         <input className={styles.inputField} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
//         <button className={styles.button} onClick={handleSignUp}>Sign Up</button>
//         <Link to="/signIn" className={styles.link}>Already have an account? Sign In here.</Link>
//       </div>
//       {showModal && <Modal message={modalMessage} onClose={() => setShowModal(false)} />}
//     </div>
//   );
// }

// export default SignUpComponent;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import styles from './authStyles.module.css';
import logoImage from '../Images/stackFrameWhite.png';

// Basic Modal Component for displaying messages
const Modal = ({ message, onClose }) => (
  <div className={styles.signUpModal}>
    <h2>Error Signing Up</h2>
    <p>{message}</p>
    <button onClick={onClose}>Close</button>
  </div>
);

function SignUpComponent() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async () => {
    const auth = getAuth();
    const db = getFirestore();

    // Check for an existing user with the same email and origin "stackFrame"
    const usersRef = collection(db, 'users');
    const usersQuery = query(usersRef, where('email', '==', email), where('origin', '==', 'stackFrame'));

    try {
      const querySnapshot = await getDocs(usersQuery);
      if (!querySnapshot.empty) {
        // Found a user with the same email
        setModalMessage('This email is already in use for a stackFrame account. Please use a different email.');
        setShowModal(true);
        return;
      }

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      // If successful, add user details to Firestore
      await addDoc(usersRef, {
        uid: userCredential.user.uid,
        email: email,
        hasPaid: false,
        origin: "stackFrame",
        projects: [],
      });

      navigate('/'); // Navigate to the dashboard
    } catch (error) {
      console.error("Error signing up:", error);
      if (error.code === 'auth/email-already-in-use') {
        setModalMessage('This email is already in use, please try again with another email.');
      } else {
        setModalMessage('An error occurred during sign up. Please try again.');
      }
      setShowModal(true);
    }
  };

  return (
    <div className={styles.parentContainer}>
      <div className={styles.container}>
        <div className={styles.stackFrame}>
          <img src={logoImage} alt="stackFrame Logo" style={{ width: '34px', height: '34px' }} />
          <span className={styles.stackFrameText}>stackFrame</span>
        </div>
        <input className={styles.inputField} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input className={styles.inputField} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className={styles.button} onClick={handleSignUp}>Sign Up</button>
        <Link to="/signIn" className={styles.link}>Already have an account? Sign In here.</Link>
      </div>
      {showModal && <Modal message={modalMessage} onClose={() => setShowModal(false)} />}
    </div>
  );
}

export default SignUpComponent;
